import React from "react"

const Youtube = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33342 12.5L12.6584 9.99996L8.33342 7.49996V12.5ZM17.9667 5.97496C18.0751 6.36663 18.1501 6.89163 18.2001 7.55829C18.2584 8.22496 18.2834 8.79996 18.2834 9.29996L18.3334 9.99996C18.3334 11.825 18.2001 13.1666 17.9667 14.025C17.7584 14.775 17.2751 15.2583 16.5251 15.4666C16.1334 15.575 15.4167 15.65 14.3167 15.7C13.2334 15.7583 12.2417 15.7833 11.3251 15.7833L10.0001 15.8333C6.50841 15.8333 4.33341 15.7 3.47508 15.4666C2.72508 15.2583 2.24175 14.775 2.03341 14.025C1.92508 13.6333 1.85008 13.1083 1.80008 12.4416C1.74175 11.775 1.71675 11.2 1.71675 10.7L1.66675 9.99996C1.66675 8.17496 1.80008 6.83329 2.03341 5.97496C2.24175 5.22496 2.72508 4.74163 3.47508 4.53329C3.86675 4.42496 4.58342 4.34996 5.68341 4.29996C6.76675 4.24163 7.75841 4.21663 8.67508 4.21663L10.0001 4.16663C13.4917 4.16663 15.6667 4.29996 16.5251 4.53329C17.2751 4.74163 17.7584 5.22496 17.9667 5.97496Z"
        fill="white" />
    </svg>
  )
}

export default Youtube
